module.exports = __webpack_public_path__ + "img/1 (113).473007a9.png";